// extracted by mini-css-extract-plugin
export var banner = "_ml-0";
export var settingRow = "_ml-2";
export var titleIcon = "_ml-1";